/**
 * Merge class names, filtering out falsy values.
 * Lightweight alternative to clsx/classnames with no dependencies.
 *
 * @param {...(string|boolean|null|undefined)} classes - Class names to merge
 * @returns {string} Merged class string
 *
 * @example
 * cn('btn', isActive && 'btn-active', disabled && 'btn-disabled')
 * // => 'btn btn-active' (if isActive=true, disabled=false)
 */
export function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}
